import * as userRequest from "@/utils/userRequest";

export default async function getRankInterestReward(
  token: string,
  onSuccess?: (data?: any) => any,
  handleError?: (err?: any) => any
) {
  try {
    const res = await userRequest.get("interests/reward", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("🚀 ~ getRankInterestReward ~ res:", res);
    if (res) {
      onSuccess && onSuccess(res);
      return res;
    }
  } catch (err) {
    console.error("🚀 ~ getRankInterestReward ~ err:", err);
    handleError && handleError(err);
    throw err;
  }
}
